import React from 'react'
import type { Icon } from 'shared/utils'

const HeartFamily = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'heart-family',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <path
                d="M20.282 4.704A5.856 5.856 0 0012 4.726a5.856 5.856 0 00-8.282-.022c-2.293 2.281-2.346 5.957.176 8.48L12 21.291c.789-.789 5.291-5.294 8.107-8.109 2.522-2.522 2.468-6.198.175-8.479zm-9.395 2.643a.69.69 0 110 1.378.69.69 0 010-1.378zM8.413 9.824a.46.46 0 110 .919.46.46 0 010-.919zm.583 2.699h-.085l-.211 2.1c0 .092-.075.156-.167.156h-.24c-.092 0-.167-.064-.167-.156l-.21-2.1H7.83a.279.279 0 01-.274-.28l.155-1.055c0-.151.123-.261.274-.261h.857c.15 0 .274.11.274.261l.155 1.055a.28.28 0 01-.275.28zm2.766-1.128h-.128l-.316 3.15c0 .139-.112.235-.25.235h-.361c-.138 0-.25-.096-.25-.234l-.317-3.151h-.128a.419.419 0 01-.41-.42l.232-1.583c0-.226.184-.392.41-.392h1.285c.227 0 .411.166.411.392l.234 1.583c0 .227-.184.42-.412.42zm3.968-.745a.383.383 0 110 .766.383.383 0 010-.766zm-2.14-2.89a.651.651 0 110 1.302.651.651 0 010-1.302zm.827 4.758h-.12l-.3 2.04c0 .131-.106.222-.236.222h-.34c-.13 0-.237-.091-.237-.221l-.299-2.04h-.12a.395.395 0 01-.389-.397l.22-2.43c0-.215.174-.37.388-.37h1.213c.215 0 .388.155.388.37l.22 2.43a.395.395 0 01-.388.396zm1.8.931h-.072l-.176 1.2c0 .077-.062.13-.139.13h-.2c-.077 0-.14-.053-.14-.13l-.175-1.2h-.07a.232.232 0 01-.229-.233l.13-1.429c0-.126.101-.218.227-.218h.714c.126 0 .229.092.229.218l.129 1.429a.233.233 0 01-.229.233z"
                fill={color}
                fillRule="nonzero"
            />
        </svg>
    )
}

export { HeartFamily }
